import { useQuery } from '@tanstack/react-query'
import api from '../api'

// Espelha o contrato do back: src/modules/reports/reports.service.ts (v2, 5 tipos)
export type ReportType =
  | 'registered'
  | 'courses-in-progress'
  | 'masterclasses-in-progress'
  | 'courses-completed'
  | 'masterclasses-completed'

export interface ReportItem {
  courseId: number
  title: string
  type: string
  progressPercent?: number // em andamento
  lastActivityAt?: string // em andamento
  completedAt?: string // concluído
}

export interface ReportRow {
  userId: string
  name: string
  email: string
  companyName: string | null
  registeredAt: string
  items: ReportItem[]
}

export interface Report {
  type: ReportType
  generatedAt: string
  period: { from: string | null; to: string | null }
  usesPeriod: boolean
  companies: { id: string; name: string }[]
  totalRegistered: number
  rows: ReportRow[]
}

export interface ReportFilters {
  companyIds?: string[]
  from?: string // YYYY-MM-DD
  to?: string // YYYY-MM-DD
  allTime?: boolean
}

/** Relatório v2 por tipo (super_admin). Só dispara quando `enabled`. */
export function useReport(type: ReportType, filters: ReportFilters, enabled = true) {
  return useQuery({
    queryKey: ['reports', type, filters],
    queryFn: async () => {
      const params = new URLSearchParams()
      if (filters.companyIds?.length) params.set('companyIds', filters.companyIds.join(','))
      if (filters.allTime) {
        params.set('allTime', '1')
      } else {
        if (filters.from) params.set('from', filters.from)
        if (filters.to) params.set('to', filters.to)
      }

      const response = await api.get<Report>(`/reports/${type}?${params}`)
      return response.data
    },
    enabled,
    staleTime: 1000 * 60, // 1 min
  })
}
